import React from 'react';
import Style from './Contact.module.scss';
import { Box } from "@mui/material";
import { info } from "../../info/Info";
import SocialIcon from "../home/SocialIcon";

export default function Contact({innerRef}) {
    return (
        <Box ref={innerRef} className={Style.container} id={'contact'}>
            <Box className={Style.header}>
                <h2 className={Style.title}>Contact Me</h2>
            </Box>
            <Box className={Style.content}>
                <p className={Style.reachText}>
                    Reach me out at <a href={`mailto:${info.miniBio.find(b => b.text.includes('@'))?.text}`} className={Style.emailLink}>{info.miniBio.find(b => b.text.includes('@'))?.text}</a> or visit me on LinkedIn/Github below
                </p>
                <Box className={Style.socials}>
                    {info.socials.map((social, index) => (
                        <SocialIcon key={index} link={social.link} icon={social.icon} label={social.label} />
                    ))}
                </Box>
            </Box>
        </Box>
    )
}
